import React from 'react';

export default function LoadingOverlay({ message }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] flex items-center justify-center">
      <div className="bg-dark-200 rounded-xl p-8 max-w-md w-full mx-4 text-center">
        <div className="flex flex-col items-center space-y-4">
          {/* Animated dots */}
          <div className="flex space-x-2">
            <div className="w-3 h-3 bg-accent-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-3 h-3 bg-accent-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-3 h-3 bg-accent-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
          
          {/* Message */}
          <p className="text-lg font-medium text-white">{message}</p>
          
          {/* Animated progress bar */}
          <div className="w-full h-1.5 bg-dark-300 rounded-full overflow-hidden">
            <div className="h-full bg-accent-primary rounded-full animate-progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
} 